import {playlistService} from '../services/playlist.services';

export const getPlayLists = (data ) => dispatch => {

    let playlistData = playlistService.getAllPlaylist(data);
    playlistData.then(playlistData => {
        dispatch({
            type: "PLAYLIST_DATA_SUCCESS",
            playlistData
        });
    });
}

export const searchPlaylists = ( data ) => dispatch => {

    let filteredData = data.playlistData;
    let searchvalue = data.search_text;
    if(searchvalue !== '') {
        filteredData = filteredData.filter(
            item => item.pl_name.toLowerCase().search(searchvalue.toLowerCase()) >= 0
        )
    }

    if(data.sort === 'new') {
        filteredData.sort(function(a, b){
            return b.id-a.id
        });
    }
    else if(data.sort === 'old') {
        filteredData.sort(function(a, b){
            return a.id-b.id
        });
    }
    else if(data.sort === 'az') {
        filteredData.sort(function(a, b){
            if(a.pl_name !== undefined && b.pl_name !== undefined) {
                var nameA=a.pl_name.toLowerCase(), nameB=b.pl_name.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }
    else if(data.sort === 'za') {
        filteredData.sort(function(a, b){
            if(a.pl_name !== undefined && b.pl_name !== undefined) {
                var nameA=a.pl_name.toLowerCase(), nameB=b.pl_name.toLowerCase()
                if (nameA > nameB) //sort string ascending
                    return -1
                if (nameA < nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }

    console.log(filteredData);
    dispatch({
        type: "PLAYLIST_DATA_SEARCH_SUCCESS",
        filteredData : filteredData,
        searchText : data.search_text,
        sort : data.sort,
        userid : data.userid

    });
}

export const newPlaylist = (state ) => dispatch => {

    dispatch({
        type: "NEW_PLAYLIST",
        state
    });
}

export const hideCreatePlaylist = (state ) => dispatch => {

    dispatch({
        type: "HIDE_CREATE",
        state
    });
}

export const createPlaylist = (data ) => dispatch => {

    let created = playlistService.createPlaylist(data);

    created.then(created => {

        if(data.plId !== '') {
            dispatch({
                type: "UPDATE_PLAYLIST_DETAIL",
                created
            });
        }
        else {
            dispatch({
                type: "CREATE_PLAYLIST",
                created
            });
        }

    });
}


export const getPlayListDetails = (data ) => dispatch => {

    let playlistEntry = playlistService.getPlaylistDetails(data);

    playlistEntry.then(playlistEntry => {
        dispatch({
            type: "PLAYLIST_DETAIL",
            playlistEntry: playlistEntry,
            plId : data.plId
        });
    });
}

export const addToPlaylist = (data ) => dispatch => {

    let added = playlistService.addToPlaylist(data);

    added.then(added => {
        dispatch({
            type: "UPDATE_PLAYLIST",
            added
        });

        dispatch({
            type: "REMOVE_SELECTION"
        });


    });

    return added;
}


export const removeFromPlaylist = (data ) => dispatch => {

    let removed = playlistService.removeFromPlaylist(data);

    removed.then(removed => {
        dispatch({
            type: "UPDATE_PLAYLIST",
            removed
        });
    });
}

export const deletePlaylist = (data ) => dispatch => {

    let removed = playlistService.deletePlaylist(data);

    removed.then(removed => {
        dispatch({
            type: "RESET_PLAYLIST_DETAIL",
            removed
        });
    });
}

export const savePlaylistName = (data ) => dispatch => {

    let removed = playlistService.savePlaylistName(data);

    removed.then(removed => {
        dispatch({
            type: "SAVE_PLAYLIST_NAME",
            removed
        });
    });
}

export const sortPlaylist = (data ) => dispatch => {

    let sorted = playlistService.sortPlaylist(data);

    sorted.then(added => {
        dispatch({
            type: "UPDATE_PLAYLIST",
            added
        });
    });
}




export const showPlaylistVignets = (data ) => dispatch => {

    let playlistVigData = playlistService.getPlaylistVignets(data);
    playlistVigData.then(playlistVigData => {
        dispatch({
            type: "PLAYLIST_VIGNETS",
            playlistVigData
        });
    });
}

export const resetPlaylistDetail = (data ) => dispatch => {

        dispatch({
            type: "RESET_PLAYLIST_DETAIL"
        });
}
export const showPlaylistModal = ( ) => dispatch => {

        dispatch({
            type: "SHOW_PLAYLIST_MODAL"
        });
}

export const duplicatePlaylist = (data ) => dispatch => {

    let duplicated = playlistService.duplicatePlaylist(data);

    duplicated.then(duplicated => {
        dispatch({
            type: "DUPLICATE_PLAYLIST_DETAIL",
            duplicated : duplicated,
            prevPlaylistId : data.plId
        });
    });
}

export const purgeImage = (data ) => dispatch => {

    dispatch({
        type: "CHANGE_IMAGE",
        image_path : data.image_path
    });
    let purged = playlistService.purgeImage(data);

    purged.then(purged => {
        dispatch({
            type: "PURGE_IMAGE",
            purged
        });
    });
}


// WEBPACK FOOTER //
// ./src/actions/playlist.js